import { render, staticRenderFns } from "./EventHighlightsEmptyContent.vue?vue&type=template&id=4260e1c9"
import script from "./EventHighlightsEmptyContent.vue?vue&type=script&lang=ts"
export * from "./EventHighlightsEmptyContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports